import React from "react";
import PdfListPage from "./PdfListPage";
import { usePoly } from "./PolyLayout";

export default function Notices() {
  const data = usePoly();
  return (
    <PdfListPage
      eyebrow="Communications"
      title="Notices & Circulars"
      accent="blue"
      items={data.notices_general || []}
      testid="poly-notices"
      emptyMsg="No notices or circulars have been published yet."
    />
  );
}
